import { createContext, useContext, useReducer } from 'react';

import { PaginationResponse } from '../../../../model/base/response/pagination-response';
import { ACTION_TYPES, CadastrosBasicoReducer, CadastrosBasicoState } from './cadastros-basico-reducer';
import { IBannersListResponse } from '../../../../model/admin-portal/response/banners-list-response';
import { ICategoriesNewsListResponse } from '../../../../model/admin-portal/response/categories-news-list-response';
import { INewsListRespomse } from '../../../../model/admin-portal/response/news-list-response';
import { ILinkServicesListResponse } from '../../../../model/admin-portal/response/link-services-list-response';
import { ITermPaggedRequest } from '../../../../model/admin-portal/request/term-pagged-request';

const CadastrosBasicoContext = createContext<CadastrosBasicoState | undefined>(undefined);
const CadastrosBasicoContextDispatchContext = createContext({} as any);

const CadastrosBasicoProvider = ({ children }: { children: React.ReactNode }) => {
    const [state, dispatch] = useReducer(CadastrosBasicoReducer, { file: null, dataPaginatedListResponse: { items: [] as any[], page: 0, pageSize: 1, pageCount: 0 } as PaginationResponse<IBannersListResponse | ICategoriesNewsListResponse | ILinkServicesListResponse | INewsListRespomse>, dataSearchRequest: { page: 0, pageSize: 10, term: "" } as ITermPaggedRequest } as CadastrosBasicoState);

    return (
        <CadastrosBasicoContext.Provider value={state}>
            <CadastrosBasicoContextDispatchContext.Provider value={dispatch}>
                {children}
            </CadastrosBasicoContextDispatchContext.Provider>
        </CadastrosBasicoContext.Provider>
    );
}

const useCadastrosBasicoState = () => {
    const context = useContext(CadastrosBasicoContext);
    if (context === undefined) {
        throw new Error('useHomeState must be used within a HomeProvider');
    }
    return context;
}

const useCadastrosBasicoDispatch = () => {
    const context = useContext(CadastrosBasicoContextDispatchContext);
    if (context === undefined) {
        throw new Error('useHomeDispatch must be used within a HomeProvider');
    }
    return context;
}

export { CadastrosBasicoProvider, useCadastrosBasicoDispatch, useCadastrosBasicoState, ACTION_TYPES };
